import useReadPost from "../hooks/useReadPost";
import {PaginationMain} from "../../../../components/common/pagination/PaginationMain";
import EmptyTableRow from "../../../common/EmptyTableRow";
import {useState} from "react";
import {useEditPost} from "../hooks/useEditPost";
import {useNavigate} from "react-router-dom";
import {useModal} from "../../../../hooks";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";

export default function BoardList() {
    const {handleModal} = useModal();
    const navigate = useNavigate();
    const {res, searchParam, setSearchParam, search} = useReadPost();
    const {data} = res;
    const {deletePost} = useEditPost();

    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        setSearchParam({
            ...searchParam,
            [name]: value
        });
    }

    const [checkboxArr, setCheckboxArr] = useState<string[]>([]);

    const isAllCheck = data?.postList.length !== 0 && data?.postList.every(el => checkboxArr.includes(el.postId))

    const clickAllCheck = () => {
        if (isAllCheck) {
            const list = checkboxArr.filter(el => !data?.postList.map(el => el.postId).includes(el))

            setCheckboxArr(list)
        } else {
            // @ts-ignore
            const list = [...new Set([...checkboxArr, ...data?.postList.map(el => el.postId)])]

            setCheckboxArr(list)
        }
    }

    const clickCheck = (str: string) => {
        if (checkboxArr.includes(str)) {
            const list = checkboxArr.filter(el2 => str !== el2)

            setCheckboxArr(list)
        } else {
            setCheckboxArr([...checkboxArr, str])
        }
    }

    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">게시판 검색</h3>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label htmlFor="" className="form-label frm_label">검색어</label>
                            <input
                                type="text"
                                name={"keyword"}
                                className="form-control me-0"
                                value={searchParam.keyword}
                                placeholder={'검색어를 입력해주세요'}
                                onChange={e => onChangeHandler(e)}
                                onKeyDown={e => {
                                    if (e.key === 'Enter') search();
                                }}/>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row">
                            <label htmlFor="" className="form-label frm_label">등록기간</label>
                            <div className="frm_field">
                                <div className="frm_field input_date">
                                    <input
                                        name={"startAt"}
                                        type="date"
                                        className="form-control"
                                        value={searchParam.startAt}
                                        onChange={e => onChangeHandler(e)}/>
                                    <span className="txt_range">~</span>
                                    <input
                                        name={"endAt"}
                                        type="date"
                                        className="form-control"
                                        value={searchParam.endAt}
                                        onChange={e => onChangeHandler(e)}/>
                                    <button className="btn btn-info btn_search" onClick={search}>
                                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">게시판 목록(<span>{data?.totalCount ?? 0}</span>건)</h6>
                    <div className="table_toolbar">
                        <AuthorityChecker authorityNames={['boardWriteYn']}>
                            <button
                                className="btn btn-dark w-100px"
                                onClick={() => navigate(`${process.env.PUBLIC_URL}/support/board/create`)}>
                                추가
                            </button>
                            <button
                                className="btn btn-outline-dark w-100px"
                                onClick={() => {
                                    if (checkboxArr.length === 0) {
                                        handleModal({
                                            isOpen: true,
                                            contents: "삭제할 항목을 선택해주세요.",
                                            type: "alert"
                                        })

                                        return;
                                    }

                                    deletePost(checkboxArr)
                                }}>
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt=""/>선택삭제
                            </button>
                        </AuthorityChecker>
                    </div>
                </div>

                <table className="table table-bordered my_table">
                    <thead>
                    <tr>
                        <AuthorityChecker authorityNames={['boardWriteYn']}>
                            <th style={{width: "4.4%"}}>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={isAllCheck}
                                        onClick={clickAllCheck}
                                    />
                                </div>
                            </th>
                        </AuthorityChecker>
                        <th>제목</th>
                        <th style={{width: "10%"}}>작성자</th>
                        <th style={{width: "10%"}}>작성일자</th>
                    </tr>
                    </thead>
                    <tbody>
                    {data?.postList.map((item, index) => <tr
                        className={checkboxArr.includes(item.postId) ? "lightblue clickable" : "clickable"}
                        onClick={() => navigate(`${process.env.PUBLIC_URL}/support/board/detail/${item.postId}`)}
                        key={index}>
                        <AuthorityChecker authorityNames={['boardWriteYn']}>
                            <td onClick={(e) => {
                                e.stopPropagation();
                                clickCheck(item.postId)
                            }}>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={checkboxArr.includes(item.postId)}
                                    />
                                </div>
                            </td>
                        </AuthorityChecker>
                        {/* 내부수정: 파일 첨부
                        <td className="text-start">{item.title}</td> */}
                        <td className="text-start">
                            <span>{item.title}</span>
                            {item.hasAttachment &&
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_attachment.png"}
                                    alt="첨부파일"
                                    style={{ width: "16px", marginLeft: "6px", verticalAlign: "middle" }}
                                />
                            }
                        </td>
                        <td className="text-center">{item.userName}</td>
                        <td className="text-center">{item.regAt}</td>
                    </tr>)}
                    {data?.postList.length === 0 && <EmptyTableRow colSpan={4}/>}
                    </tbody>
                </table>

                <PaginationMain totalCount={data?.totalCount ?? 0}/>

            </div>
        </>
    );
}